import React from 'react';
import { FaBolt, FaHourglassHalf } from 'react-icons/fa';

const Powerups = ({ combo, time }) => {
  // 手機版優化尺寸
  const isMobile = window.innerWidth < 768;
  const size = isMobile ? 'w-12 h-12' : 'w-14 h-14';
  const iconSize = isMobile ? 20 : 24;

  return (
    <div className="fixed bottom-16 sm:bottom-24 left-1/2 -translate-x-1/2 flex gap-3 sm:gap-4 z-40 pointer-events-none">
      {/* 連擊加成道具 */}
      <div
        className={`
          ${size} rounded-full flex items-center justify-center shadow-lg 
          transition-all duration-300
          ${combo.active 
            ? 'bg-purple-600 text-white scale-110 animate-pulse' 
            : 'bg-gray-300 text-gray-500 opacity-50 scale-90'
          }
        `}
        title="連擊加成"
      >
        <FaBolt size={iconSize} />
      </div>

      {/* 時間延長道具 */}
      <div
        className={`
          ${size} rounded-full flex items-center justify-center shadow-lg 
          transition-all duration-300
          ${time.active 
            ? 'bg-cyan-500 text-white scale-110 animate-pulse' 
            : 'bg-gray-300 text-gray-500 opacity-50 scale-90'
          }
        `}
        title="時間延長"
      >
        <FaHourglassHalf size={iconSize} />
      </div>
    </div>
  );
};

export default Powerups;